import React from "react";
import AdminCard from "./adminCard";
import "./new.css";

const New = ({ ordersFound, data, handleStatusClick, handleDeliveryClick, handleChef, handleComment, handleRefund }) => {
  const handleOrder = (orderID) => {
    window.open(`/order?orderID=${orderID}`, "_blank");
  };

  return (
    <div className="new">
      {ordersFound ? (
        data.map((data, id) => (
          <AdminCard
            id={id}
            data={data}
            handleOrder={handleOrder}
            status="NEW"
            handleChef={handleChef}
            handleStatusClick={handleStatusClick}
            handleDeliveryClick={handleDeliveryClick}
            handleComment={handleComment}
            handleRefund={handleRefund}
          />
        ))
      ) : (
        <h1>No New Orders</h1>
      )}
    </div>
  );
};

export default New;
